import {observer, React} from '@api'
import {Icon, IconName} from '@blueprintjs/core'
import {icons} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import {MouseEventHandler} from 'react'
import * as css from './LargeButton.css'

interface ILargeButton {
  icon: any
  title: string
  subtitle: string
  onClick: MouseEventHandler<HTMLDivElement>
}

export const LargeButton = observer<ILargeButton>(function LargeButton({icon, title, subtitle, onClick}) {
  return (
    <div className={css.root} onClick={onClick}>
      {icon && <PrimaryIconButton className={css.icon}>{icon}</PrimaryIconButton>}
      <div className={css.content}>
        <div className={css.title}>{title}</div>
        <div className={css.subtitle}>{subtitle}</div>
      </div>
    </div>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/LargeButton.tsx